import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Consent() {
  const [text, setText] = useState("");

  useEffect(() => {
    document.title = "Согласие на обработку персональных данных — vip77.store";
    api.get("/settings").then((r) => setText(r.data.consent_text || "")).catch(() => {});
  }, []);

  const paragraphs = text.split(/\n\n+/).filter(Boolean);

  return (
    <div data-testid="consent-page" className="mx-auto max-w-3xl px-4 py-16 lg:px-8">
      <div className="text-[11px] font-bold uppercase tracking-[0.24em] text-muted-soft">Документы</div>
      <h1 className="mt-2 text-4xl font-extrabold tracking-tightest text-ink">Согласие на обработку персональных данных</h1>
      <div className="mt-8 space-y-4">
        {paragraphs.map((p, i) => (
          <p key={i} className="text-sm leading-relaxed text-muted">{p}</p>
        ))}
      </div>
    </div>
  );
}
